/**
 * Auto-submits the accessories collection sort <select> on change,
 * matching the plain "Sort by X" dropdown behavior from the WP reference.
 */
document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-accessories-sort]');
  if (select && select.form) {
    select.form.submit();
  }
});
